import React, { useState } from "react";

interface TrafficEstimatorProps {}

const TrafficEstimatorPage: React.FC<TrafficEstimatorProps> = () => {
  const [adFormat, setAdFormat] = useState<string>("");
  const [platformType, setPlatformType] = useState<string>("");
  const [trafficSourceType, setTrafficSourceType] = useState<string>("");

  const handleGenerate = () => {
    if (!adFormat || !platformType || !trafficSourceType) {
      alert("Please select all fields to generate traffic estimation.");
      return;
    }
    // Logic for fetching or calculating traffic estimation goes here
    console.log("Generating traffic estimation...");
  };

  return (
    <div className="p-6 bg-white shadow-md rounded-lg max-w-lg mx-auto" style={{padding:'30px',height:'80%',width:'60%', boxShadow:'6px 4px 10px 5px rgba(0, 0, 0, 0.2)'}}>
      <h2 className="text-x font-bold mb-4" style={{fontSize:'14px'}}>Traffic Estimator</h2>
      <p className="text-sm mb-4">
        Choose ad format and platform type to view daily traffic estimation and
        recommended minimum bid:
      </p>

      <div className="space-y-4" style={{display:'flex'}}>
        <div>
          <label htmlFor="adFormat" className="block text-sm font-medium">
            {/* Ad Format */}
          </label>
          <select
          style={{padding:'3px', borderColor: '#D3D3D3', marginRight:'5px', fontSize:'12px', backgroundColor:'#F5F5F5', borderWidth:'0.1px'}}
            id="adFormat"
            className="p-2 border rounded-lg"
            value={adFormat}
            onChange={(e) => setAdFormat(e.target.value)}
          >
            <option value="">Select Ad Format</option>
            <option value="banner">Banner</option>
            <option value="video">Video</option>
            <option value="native">Native</option>
          </select>
        </div>

        <div>
          <label htmlFor="platformType" className="block text-sm font-medium">
            {/* Platform Type */}
          </label>
          <select
          style={{padding:'3px', borderColor: '#D3D3D3',marginRight:'5px', fontSize:'12px', backgroundColor:'#F5F5F5', borderWidth:'0.1px'}}
            id="platformType"
            className="w-full p-2 border rounded-lg"
            value={platformType}
            onChange={(e) => setPlatformType(e.target.value)}
          >
            <option value="">Select Platform Type</option>
            <option value="web">Web</option>
            <option value="mobile">Mobile</option>
            <option value="desktop">Desktop</option>
          </select>
        </div>

        <div>
          <label
            htmlFor="trafficSourceType"
            className="block text-sm font-medium"
          >
            {/* Traffic Source Type */}
          </label>
          <select
          style={{padding:'3px', borderColor: '#D3D3D3', fontSize:'12px', backgroundColor:'#F5F5F5', borderWidth:'0.1px', marginRight:'5px'}}
            id="trafficSourceType"
            className="w-full p-2 border rounded-lg"
            value={trafficSourceType}
            onChange={(e) => setTrafficSourceType(e.target.value)}
          >
            <option value="">Select Traffic Source Type</option>
            <option value="search">Search</option>
            <option value="social">Social</option>
            <option value="direct">Direct</option>
          </select>
        </div>


        <button
      style={{ padding:'3px 10px', backgroundColor:'#81D34A', color:'white', borderColor:'transparent', fontSize:'10p'}}
        className="mt-6 w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600"
        onClick={handleGenerate}
      >
        Generate
      </button>
      </div>

     
    </div>
  );
};

export default TrafficEstimatorPage;

